'use client';

import { HeartIcon } from '../../Modules/ProductToolbar/FavouritesCount';

/**
 * Renders a MarkFavourite component with an avatar and a heart icon.
 * The heart icon can be filled or outlined based on the `isFavourite` prop.
 * Clicking on the avatar triggers the `onClick` function.
 *
 * @param {boolean} isFavourite - A boolean value indicating whether the heart icon should be filled or outlined. Default is `false`.
 * @param {(productDetails: FavouriteProduct) => void} onClick - A function to be called when the avatar is clicked.
 * @returns {JSX.Element} - The rendered MarkFavourite component.
 */
/**
 * Represents a button with a heart icon that can be marked as a favorite or not.
 * Triggers an `onClick` event when clicked.
 *
 * @param {boolean} isFavourite - Indicates whether the button should be marked as a favorite. Default is `false`.
 * @param {function} onClick - Function to be called when the button is clicked. Default is an empty function.
 * @param {number} iconWidth - Width of the heart icon. Default is `24`.
 * @param {string} btnClass - Additional CSS class(es) to be applied to the button.
 * @param {string} iconClass - Additional CSS class(es) to be applied to the heart icon.
 * @returns {JSX.Element} - JSX element representing a button with a heart icon.
 */
export const MarkFavourite = ({
  isFavourite = false,
  onClick = () => {},
  iconWidth = 24,
  btnClass = '',
  iconClass = '',
}): React.ReactElement => {
  return (
    <button
      className={`!ui-bg-white !ui-z-0 ui-rounded-[50%] ui-inline-flex  ui-border-none ui-items-center ui-justify-center ${btnClass}`}
      onClick={onClick}
    >
      <HeartIcon active={isFavourite} width={iconWidth} className={iconClass} />
    </button>
  );
};
